export default "__VITE_ASSET__57210175__"